import React from 'react'
import { PaginaNode } from '@gql/graphql'
import { PlaceholderReact } from '@components/molecules'
import { GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './PagebuilderTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const PagebuilderTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const defaultContent1 = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <Prefooter />
      </main>
    </Page>
  )
}

export default PagebuilderTemplate
